import React from "react";
import { MainDialog } from "../Dialgos/MainDialog";
import NotificationForm from "./form/NotificationForm";
import { Button } from "../ui/button";
import { IoIosAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
function AddNotificationModel() {
  const { t } = useTranslation();
  const { createNotificationFunction } = indexStore();

  const handleSubmit = (values) => {
    createNotificationFunction({ ...values, type: "notification" });
    console.log(values, "values");
  };
  return (
    <MainDialog
      title={`${t("gloabl.add")} ${t(`gloabl.notification`)}`}
      trigger={
        <Button className="">
          <IoIosAdd />
          <span className="ml-2 hidden md:block">
            {t("gloabl.add")} {t(`gloabl.notification`)}
          </span>
        </Button>
      }
    >
      <NotificationForm editMode={false} onSubmit={handleSubmit} />
    </MainDialog>
  );
}

export default AddNotificationModel;
